import React from 'react';

export function ToolElem({ children, label }:
{ children: JSX.Element, label: string }) {
  return (
    <div className="tool-elem">
      <div className="tool-image">{children}</div>
      <div className="tool-text">{label}</div>
    </div>
  );
}
